var _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgArrowSprite(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    style: {
      position: "absolute",
      width: 0,
      height: 0
    },
    width: 0,
    height: 0,
    xmlns: "http://www.w3.org/2000/svg",
    xlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("symbol", {
    id: "arrow",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(24 24) rotate(180)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24,24V0H0V24Z",
    fill: "none",
    opacity: 0.87
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.59,8.59,15.17,10,12,6.83,8.83,10,7.41,8.59,12,4Z",
    transform: "translate(24 19) rotate(180)"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowSprite);
export default __webpack_public_path__ + "static/media/arrow_sprite.b9d9ad93f3b21d59332f5eea8d034e4d.svg";
export { ForwardRef as ReactComponent };